
export type RequestAdminAccountRefundBody = {
  orderId: string;
  reason: string;
  userId: string;
};
